export default __webpack_public_path__ + "static/media/eggplant.0cd3c2cb.jpg";